<template>
  <el-dialog
    :title="mode === 'create' ? '新增模板' : '修改模板名称'"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="90px"
    >
      <el-form-item label="模板名称" prop="templateName">
        <el-input
          v-model.trim="form.templateName"
          size="small"
          maxlength="30"
          placeholder="请输入"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button type="primary" size="small" :loading="saving" @click="onSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "CreateRenameDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "create",
    },
    editId: {
      type: [Number, String],
      default: null,
    },
    initialName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      saving: false,
      form: {
        templateName: "",
      },
      rules: {
        templateName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.form.templateName = this.mode === "rename" ? this.initialName : "";
        this.$nextTick(() => {
          this.$refs.form?.clearValidate();
        });
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("update:visible", false);
      }
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        this.$emit("submit", {
          mode: this.mode,
          id: this.editId,
          name: this.form.templateName.trim(),
          done: () => {
            this.saving = false;
            this.dialogVisible = false;
          },
          fail: () => {
            this.saving = false;
          },
        });
      });
    },
  },
};
</script>
